const CODICI = {
  "00002": "Nome del file già usato: invia di nuovo la fattura, il programma assegna un nuovo nome al file.",
  "00100": "Certificato di firma scaduto: riprova l'invio più tardi; se si ripete contatta lo Studio Principale.",
  "00102": "Firma digitale non valida: riprova l'invio; se si ripete contatta lo Studio Principale.",
  "00200": "Il file non rispetta il formato della fattura elettronica: controlla dati obbligatori, caratteri speciali e lunghezza dei campi.",
  "00300": "Partita IVA del trasmittente non valida: contatta lo Studio Principale.",
  "00301": "La tua partita IVA (cedente) non risulta valida in Anagrafe Tributaria: controllala nelle Impostazioni dell'azienda.",
  "00303": "Partita IVA del rappresentante fiscale non valida: correggila o toglila.",
  "00305": "La partita IVA del cliente non esiste in Anagrafe Tributaria: correggila nella scheda del cliente (o usa solo il codice fiscale se è un privato).",
  "00306": "Il codice fiscale del cliente non è valido: correggilo nella scheda del cliente.",
  "00311": "Il codice destinatario del cliente non esiste: chiedi al cliente il codice SdI corretto (7 caratteri) oppure usa 0000000 con la sua PEC.",
  "00312": "Il codice destinatario del cliente non è attivo: chiedi al cliente un codice SdI valido oppure usa 0000000 con la sua PEC.",
  "00400": "Manca la natura IVA sulle righe con aliquota 0%: scegli la natura corretta (es. N2.2 forfettari, N4 esenti).",
  "00401": "Hai indicato una natura IVA su una riga con aliquota maggiore di 0: togli la natura o metti l'aliquota a 0%.",
  "00403": "La data della fattura è successiva alla data di invio: correggi la data documento (non può essere futura).",
  "00404": "Fattura duplicata: esiste già una fattura con lo stesso numero, data e tipo. Se la precedente è stata consegnata non reinviare; altrimenti cambia numero.",
  "00409": "Fattura duplicata nello stesso invio: controlla numero e data.",
  "00411": "C'è una ritenuta sulle righe ma mancano i dati della ritenuta: compila la sezione Ritenute o togli la ritenuta dalle righe.",
  "00413": "Manca la natura IVA del contributo cassa previdenziale con aliquota 0%: indicala nella sezione Cassa.",
  "00414": "Natura IVA indicata sul contributo cassa con aliquota maggiore di 0: toglila.",
  "00415": "Ritenuta sulla cassa previdenziale ma mancano i dati ritenuta: compila la sezione Ritenute.",
  "00417": "Mancano sia la partita IVA sia il codice fiscale del cliente: inseriscine almeno uno nella scheda del cliente.",
  "00418": "La data della fattura è precedente a quella del documento collegato (es. nota di credito): correggi le date.",
  "00419": "Riepilogo IVA incompleto: c'è un'aliquota o natura nelle righe senza riepilogo. Salva di nuovo la fattura per ricalcolarlo.",
  "00420": "Natura N6 (reverse charge) non compatibile con lo split payment: togli lo split payment o cambia la natura.",
  "00421": "L'imposta calcolata non corrisponde: controlla aliquote e importi delle righe e salva di nuovo.",
  "00422": "L'imponibile del riepilogo non corrisponde alla somma delle righe: controlla gli importi e salva di nuovo.",
  "00423": "Il totale di una riga non corrisponde a quantità × prezzo con lo sconto: controlla la riga.",
  "00424": "Aliquota IVA non valida: usa un'aliquota in percentuale (es. 22, 10, 4).",
  "00425": "Il numero della fattura deve contenere almeno una cifra: correggi il numero.",
  "00427": "Codice destinatario non coerente con il tipo di cliente: per i privati e le aziende usa 7 caratteri, per la Pubblica Amministrazione 6.",
  "00428": "Formato di trasmissione non coerente con il cliente (privato o Pubblica Amministrazione): controlla il codice destinatario.",
  "00429": "Natura IVA generica non più valida (N2, N3, N6): scegli quella specifica, es. N2.2, N3.1, N6.3.",
  "00430": "Natura IVA generica non più valida sul contributo cassa: scegli quella specifica.",
  "00437": "Sconto o maggiorazione non coerente con l'importo: controlla la sezione sconto sul totale.",
  "00444": "La natura IVA scelta non è ammessa per questo tipo di documento: cambia natura o tipo documento.",
  "00445": "Natura IVA generica non ammessa: scegli quella specifica (es. N2.1, N2.2, N3.1).",
  "00471": "Per questo tipo documento (autofattura/integrazione) cedente e cliente non possono coincidere, salvo i casi ammessi: controlla tipo documento e anagrafica.",
  "00473": "Tipo documento non ammesso per una fattura verso la Pubblica Amministrazione o per questo cliente: controlla il tipo documento.",
};

const PAROLE = [
  [/duplicat/i, CODICI["00404"]],
  [/partita iva|idfiscaleiva/i, "Controlla la partita IVA del cliente e la tua nelle Impostazioni."],
  [/codice ?destinatario/i, CODICI["00311"]],
  [/firma|certificato/i, CODICI["00100"]],
  [/natura/i, CODICI["00429"]],
];

export const consigliScarto = (note) => {
  const txt = String(note || "");
  const out = [...new Set((txt.match(/\b00\d{3}\b/g) || []).map((c) => CODICI[c] && `${c}: ${CODICI[c]}`).filter(Boolean))];
  if (!out.length) {
    const p = PAROLE.find(([re]) => re.test(txt));
    if (p) out.push(p[1]);
  }
  return out;
};

export const ConsigliScarto = ({ note, testid = "scarto-consigli", className = "" }) => {
  const c = consigliScarto(note);
  if (!c.length) return null;
  return (
    <ul data-testid={testid} className={`mt-1.5 space-y-0.5 rounded-md bg-white/70 px-2.5 py-1.5 text-xs text-slate-700 ${className}`}>
      {c.map((x) => <li key={x}><b className="text-emerald-700">Cosa fare · </b>{x}</li>)}
    </ul>
  );
};
